<template lang="html">
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-card-title primary-title class="grey lighten-4">
          <v-tooltip top>
                  <v-btn
                        slot="activator"
                        dark
                        @click.stop="dialog = true"
                        icon class="mx-0">
                     <v-icon color="red">help</v-icon>
                 </v-btn>
             <span>Universidades</span>
          </v-tooltip>
          <h3 class="headline mb-0">Administración de Universidades</h3>
          <v-spacer></v-spacer>
          <v-btn color="info" @click="nuevaUniversidad">Agregar</v-btn>
        </v-card-title>
          <v-card-title primary-title class="grey lighten-4">
            <v-spacer></v-spacer>
            <v-text-field
              :loading="loading"
              v-model="search"
              label="Buscar"
              single-line
              hide-details
              :append-outer-icon="loading ? 'update' : 'search'"
              @click:append-outer="searchFilterUniversity"
              @change="searchFilterUniversity"
            ></v-text-field>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table
               :loading="loading"
               :headers="headers"
               :items="all_universities"
               rows-per-page-text="Filas por Pág"
               hide-actions
               :pagination.sync="pagination"
             >
               <template slot="items" slot-scope="props">
                 <!-- <td>
                    <v-avatar size="36px">
                        <img v-if="props.item.picture" :src="props.item.picture" :alt="props.item.name">
                        <v-icon v-else color="primary">not_interested</v-icon>
                    </v-avatar>
                 </td> -->
                 <td>{{ props.item.code }}</td>
                 <td>{{ props.item.name }} </td>
                 <td class="justify-center layout px-0">
                    <!-- <v-tooltip top>
                        <v-btn :loading="this.uploadPhoto" :disabled="props.item.all_universities == null" slot="activator" icon class="mx-0" @click="uploadPhotoAgremiado(props.item.all_universities)">
                          <v-icon color="black">image</v-icon>
                        </v-btn>
                        <span>Logo de la Universidad</span>
                    </v-tooltip> -->

                    <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" @click="verUniversidad(props)">
                          <v-icon color="blue darken-2">description</v-icon>
                        </v-btn>
                        <span>Ver</span>
                    </v-tooltip>


                    <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" @click="editarUniversidad(props)">
                          <v-icon color="green">edit</v-icon>
                        </v-btn>
                        <span>Editar Universidad</span>
                    </v-tooltip>

                   <v-tooltip top>
                        <!-- <v-btn slot="activator" @click="eliminarUniversidad" icon class="mx-0"> -->
                        <v-btn slot="activator" icon @click.native="eliminarUniversidad(props.item.id)">
                          <v-icon color="red">delete</v-icon>
                        </v-btn>
                        <span>Eliminar Universidad</span>
                    </v-tooltip>

                 </td>
               </template>
               <v-alert slot="no-results" :value="true" color="error" icon="warning">
                 La busqueda para  "{{ search }}" No resultó.
               </v-alert>
             </v-data-table>

            <div class="text-xs-center">
                <v-layout justify-center>
                  <v-flex xs8>
                    <v-card class="elevation-0">
                      <v-card-text>
                        <v-pagination
                          v-model="page"
                          :length="pages"
                        ></v-pagination>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
            </div>

          </v-card-text>
      </v-card>
    </v-flex>


    <!-- dialog para form universities -->
    <v-dialog
      v-model="dialogFormUniversity"
      width="600"
    >
      <FormUniversities :tipo="tipo" :datos="getUniversities" v-on:closeDialogUniversity="closeDialogUniversity($event)" />
    </v-dialog>
    <!-- fin dialog form universities -->
      <input hidden type="file" ref="fileInput" @change="processFile($event)">

      <UploadFile :showUpload="uploadPhoto"  :cpc="uploadcpc" v-on:upload="uploadPhoto = $event" v-on:userdata="setUsersData" />
    <!-- Inicio de dialogo -->
    <v-dialog
      v-model="dialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">Registro de Universidades</v-card-title>

        <v-card-text>
          Lista de Universidades para ser usadas desde la carga del agremiado en su educación formal de pregrado.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="dialog = false"
          >
            Salir
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->

  </v-layout>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import FormUniversities from '~/components/form/formUniversities.vue'
import UploadFile from '~/components/logouniversidad/upload_file.vue'

export default {
    name: 'universities-view',

    components: {
      FormUniversities,
      UploadFile
    },

    computed: {
        ...mapGetters({
            authenticated: 'authCheck'
        }),
        getUniversities () {
          return this.editItem
        },
        pages () {
            return this.pagination.total
        }
    },

    mounted() {
        this.initComponent(1)
    },

    watch: {
      page(v) {
        if(this.activePagination){
          this.initComponent(v)
        }
        this.activePagination = true
      }
    },

    data () {
        return {
            dialog: false,
            all_universities: [],
            dialogFormUniversity: false,
            uploadcpc: '',
            activePagination: false,
            loading: false,
            uploadPhoto: false,
            search: '',
            page: 0,
            tipo: '',
            editItem: {},
            pagination: {
                page: 1,
                totalItems: 0,
                rowsPerPage: 10,
                total: 0
            },
            headers: [
                { text: 'SIGLAS', value: 'code', sortable: false },
                { text: 'UNIVERSIDAD', value: 'name', sortable: false },
                { text: 'ACCIONES', value: 'acciones', sortable: false }
            ],
        }
    },

    methods: {

        async initComponent (page,search=null) {
            this.loading = true
            const url = search == null ? `/api/universities/admin/getUniversities?page=${page}` : `/api/universities/admin/getUniversities?page=${page}&search=${search}`
            await axios.get(url)
                .then(resp => {
                  //console.log(resp)
                    this.all_universities = resp.data.all_universities.data
                    this.page = resp.data.all_universities.current_page
                    this.pagination = {
                        total: resp.data.all_universities.last_page,
                        totalItems: resp.data.all_universities.total,
                        rowsPerPage: resp.data.all_universities.per_page,
                        page: 1
                    }
                })
                .catch(e => {
                    console.log(e.response,"error");
                })

            this.loading = false
        },

        nuevaUniversidad () {
          this.tipo = "crear"
          this.editItem = {}
          this.dialogFormUniversity = true
        },

        verUniversidad (props) {
          this.tipo = "ver"
          this.editItem = props.item
          this.dialogFormUniversity = true
        },

        eliminarUniversidad (id) {
          let confirmDelete = confirm('Seguro que desea eliminar el registro?')
          if (confirmDelete) {
            axios.delete('/api/universities/admin/' + id)
            .then(response => {
              //console.log(response)
              this.searchFilterUniversity()
            })
            .catch(error => {
              console.log(error.response);
            });
          }
        },

        editarUniversidad (props) {
          this.tipo = "editar"
          this.editItem = props.item
          this.dialogFormUniversity = true
        },
        setUsersData (props) {
          let item = this.all_universities.find(uni => uni.id === props.id)
          Object.assign(item, props)
        },


        searchFilterUniversity () {
            this.initComponent(this.page,this.search)
        },

        closeDialogUniversity (response) {
          if (response != null) {
            var item = this.all_universities.find(all_universitie => all_universitie.id === response.id)
            if (this.tipo == 'crear') {
              this.all_universities.push(response)
            }else {
              Object.assign(item, response)
            }
            //this.search = response.email
          }
          this.dialogFormUniversity = false
          setTimeout(function(){
            this.editItem = {}
            this.tipo = ''
          }, 3000)
          this.searchFilterUniversity()
        }

    }

}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/atencion/universities.vue